export const translations = {
    store: {
        es: "Tienda",
        en: "Store"
    }
}